import type { Component } from "vue";

import AppleIcon from "./brands/apple.svg";
import ArenaIcon from "./brands/arena.svg";
import BlueskyIcon from "./brands/bluesky.svg";
import ButtondownIcon from "./brands/buttondown-color.svg";
import CarrdIcon from "./brands/carrd.svg";
import DiscordIcon from "./brands/discord.svg";
import GhostIcon from "./brands/ghost.svg";
import GitHubIcon from "./brands/github.svg";
import GoogleIcon from "./brands/google-color.svg";
import LinkedinIcon from "./brands/linkedin.svg";
import MailchimpIcon from "./brands/mailchimp.svg";
import MemberfulIcon from "./brands/memberful-color.svg";
import MetaIcon from "./brands/meta.svg";
import SendyIcon from "./brands/sendy.svg";
import ShopifyIcon from "./brands/shopify.svg";
import SlackIcon from "./brands/slack.svg";
import SquarespaceIcon from "./brands/squarespace.svg";
import StripeIcon from "./brands/stripe.svg";
import SubstackColorIcon from "./brands/substack-color.svg";
import SubstackIcon from "./brands/substack.svg";
import TinyletterIcon from "./brands/tinyletter.svg";
import TumblrIcon from "./brands/tumblr.svg";
import TwitterIcon from "./brands/twitter.svg";
import WebflowIcon from "./brands/webflow.svg";
import ZapierIcon from "./brands/zapier.svg";

export const brandIconMapping = {
  apple: AppleIcon,
  arena: ArenaIcon,
  bluesky: BlueskyIcon,
  buttondown: ButtondownIcon,
  carrd: CarrdIcon,
  discord: DiscordIcon,
  ghost: GhostIcon,
  github: GitHubIcon,
  google: GoogleIcon,
  linkedin: LinkedinIcon,
  mailchimp: MailchimpIcon,
  memberful: MemberfulIcon,
  meta: MetaIcon,
  sendy: SendyIcon,
  shopify: ShopifyIcon,
  slack: SlackIcon,
  squarespace: SquarespaceIcon,
  stripe: StripeIcon,
  substack_color: SubstackColorIcon,
  substack: SubstackIcon,
  tinyletter: TinyletterIcon,
  tumblr: TumblrIcon,
  twitter: TwitterIcon,
  webflow: WebflowIcon,
  zapier: ZapierIcon,
} satisfies Record<string, Component>;

export type MappedBrandIcon = keyof typeof brandIconMapping;
